"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var semantic_ui_react_1 = require("semantic-ui-react");
var ConfirmModal = function (_a) {
    var open = _a.open, onCancel = _a.onCancel, onConfirm = _a.onConfirm, headerTitle = _a.headerTitle, cancelButtonTitle = _a.cancelButtonTitle, confirmButtonTitle = _a.confirmButtonTitle, content = _a.content, size = _a.size;
    return (react_1.default.createElement(semantic_ui_react_1.Confirm, { className: styles_module_scss_1.default.confirm_modal, open: open, onCancel: onCancel, onConfirm: onConfirm, size: size, header: {
            content: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("i", { className: "icon-ic-error" }),
                react_1.default.createElement("span", null, headerTitle))),
        }, cancelButton: cancelButtonTitle, confirmButton: confirmButtonTitle, content: content }));
};
ConfirmModal.defaultProps = {
    size: 'tiny',
};
exports.default = ConfirmModal;
